import { CardType } from 'modules/PendingForApproval/types'

export const OPERATOR_ACTION_BUTTONS_SECTIONS = {
  Profile: CardType.PROFILE,
  Locations: CardType.LOCATION,
  Documents: CardType.DOCUMENTS,
  Cars: CardType.CARS,
  PriceLists: CardType.PRICE_LIST,
  TermsAndConditions: CardType.TERMS,
}
